type RecordBytes = (bytes: number) => void;

function readContentLength(response: Response): number | null {
  const raw = response.headers.get("content-length");
  if (!raw || !/^\d+$/.test(raw)) return null;
  const parsed = Number(raw);
  return Number.isSafeInteger(parsed) ? parsed : null;
}

function chunkByteLength(chunk: unknown): number {
  if (typeof chunk === "string") return new TextEncoder().encode(chunk).byteLength;
  if (chunk instanceof ArrayBuffer) return chunk.byteLength;
  if (ArrayBuffer.isView(chunk)) return chunk.byteLength;
  if (chunk instanceof Blob) return chunk.size;
  return 0;
}

export function meterResponseBandwidth(response: Response, recordBytes: RecordBytes): Response {
  const contentLength = readContentLength(response);
  if (contentLength !== null) {
    if (contentLength > 0) recordBytes(contentLength);
    return response;
  }

  if (!response.body) return response;

  let totalBytes = 0;
  const meteredBody = response.body.pipeThrough(
    new TransformStream({
      transform(chunk, controller) {
        totalBytes += chunkByteLength(chunk);
        controller.enqueue(chunk);
      },
      flush() {
        if (totalBytes > 0) recordBytes(totalBytes);
      },
    }),
  );

  return new Response(meteredBody, {
    status: response.status,
    statusText: response.statusText,
    headers: response.headers,
  });
}
